<template>
  <div class="">
    <div class="tool">
      <div class="b-container" :class="{'klick_reaktion': 0==klick}"><button @click="neuesSpiel()" title="Neues Spiel" >
        <svg height="24px" viewBox="0 0 104 92" >
          <g id="3.Multimedia" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
            <rect fill="#FF7171" x="0" y="0" width="100" height="88" rx="18"></rect>
            <path d="M37,26.8868147 C37,25.2334391 38.1509965,24.5861607 39.5682678,25.4395396 L67.8692915,42.4803815 C69.2877066,43.3344491 69.2865628,44.719855 67.8692915,45.5732339 L39.5682678,62.6140758 C38.1498526,63.4681434 37,62.8207339 37,61.1668007 L37,26.8868147 Z" id="Layer-2" fill="#FFFFFF"></path>
          </g>
        </svg>
      </button></div>
      <div class="b-container" :class="{'klick_reaktion': 1==klick}"><button @click="undo()" title="Zurück">
        <svg width="24px" viewBox="0 0 48 48" >
          <g fill="rgb(216, 165, 99)">
            <polygon points="5,18 19,6.3 19,29.7"/>
            <path d="M28,14H16v8h12c2.8,0,5,2.2,5,5s-2.2,5-5,5h-3v8h3c7.2,0,13-5.8,13-13S35.2,14,28,14z"/>
          </g>
        </svg>
      </button></div>
      <div class="b-container" :class="{'klick_reaktion': 2==klick}"><button @click="redo()" title="Vorwerts" >
        <svg width="24px" viewBox="0 0 48 48" >
          <g fill="rgb(38, 189, 33)">
            <polygon points="43,18 29,6.3 29,29.7"/>
            <path d="M20,14h12v8H20c-2.8,0-5,2.2-5,5s2.2,5,5,5h3v8h-3c-7.2,0-13-5.8-13-13S12.8,14,20,14z"/>
          </g>
        </svg>
      </button></div>
      <div class="b-container" :class="{'klick_reaktion': 3==klick}"><button @click="gruppe()" title="Paare suchen">
        <svg width="24px" viewBox="0 0 30 30" >
          <path class="st8" d="M16,20l6.5,6.5c0.8,0.8,2.2,0.8,3,0l0,0c0.8-0.8,0.8-2.2,0-3L19,17L16,20z"
            fill="#1F992A" stroke="rgb(74, 74, 252)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" />
          <circle class="st9" cx="12" cy="12" r="9"
            fill="rgb(214, 214, 252)" stroke="rgb(74, 74, 252)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" />
        </svg>
      </button></div>
      <div class="b-container" :class="{'klick_reaktion': 4==klick}"><button @click="zeigeZug()" title="Hinweis">
        <svg width="24px" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="11" stroke="#1245C6"  fill="none"  stroke-width="2"/>
          <path d="M11,16 L13,16 L13,18 L11,18 L11,16 Z
          M12.61,6.04 C10.55,5.74 8.73,7.01 8.18,8.83 C8,9.41 8.44,10 9.05,10 L9.25,10 C9.66,10 9.99,9.71 10.13,9.33 C10.45,8.44 11.4,7.83 12.43,8.05 C13.38,8.25 14.08,9.18 14,10.15 C13.9,11.49 12.38,11.78 11.55,13.03 C11.55,13.04 11.54,13.04 11.54,13.05 C11.53,13.07 11.52,13.08 11.51,13.1 C11.42,13.25 11.33,13.42 11.26,13.6 C11.25,13.63 11.23,13.65 11.22,13.68 C11.21,13.7 11.21,13.72 11.2,13.75 C11.08,14.09 11,14.5 11,15 L13,15 C13,14.58 13.11,14.23 13.28,13.93 C13.3,13.9 13.31,13.87 13.33,13.84 C13.41,13.7 13.51,13.57 13.61,13.45 C13.62,13.44 13.63,13.42 13.64,13.41 C13.74,13.29 13.85,13.18 13.97,13.07 C14.93,12.16 16.23,11.42 15.96,9.51 C15.72,7.77 14.35,6.3 12.61,6.04 Z" 
          fill="#1D1D1D" stroke="#FF7171" />
        </svg>
        <span class="zeige-anzahl">{{anzahl}}</span>
      </button></div>
      <div class="b-container" :class="{'klick_reaktion':5==klick}"><button @click="setFaktor(-0.5)">
        <svg width="24px" viewBox="0 0 24 24" fill="none" stroke="#1245C6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" 
        class="feather feather-plus-square">
        <rect x="1" y="1" width="22" height="22" rx="4" ry="4" stroke-width="2" ></rect>
        <line x1="6" y1="12" x2="18" y2="12"></line>
        </svg>
      </button></div>
      <div class="b-container" :class="{'klick_reaktion': 6==klick}"><button @click="setFaktor(0.5)">
        <svg width="24px" viewBox="0 0 24 24" fill="none" stroke="#1245C6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" 
        class="feather feather-plus-square">
        <rect x="1" y="1" width="22" height="22" rx="4" ry="4" stroke-width="2"></rect>
        <line x1="12" y1="6" x2="12" y2="18"></line>
        <line x1="6" y1="12" x2="18" y2="12"></line>
        </svg>
      </button></div>
    
      <div class="b-container" :class="{'klick_reaktion': 7==klick}"><button @click="chgThema()">
        <svg width="44px" viewBox="0 0 42 24" >
          <polygon  points="0 0 21 0 21 24 0 24" :fill="fillT[thema]"></polygon>
          <polygon  points="21 0 40 0 40 24 21 24" :fill="fillT[1-thema]"></polygon>
          <rect x="1" y="1" width="40" height="22" rx="4" ry="4" fill="none" stroke="#1245C6" stroke-width="2"></rect>
          <path d="M12,17 L14,17 L14,7 L10,7 L10,9 L12,9 L12,17 Z"
                 stroke="#000" fill="#000"></path>
          <path d="M35,15 L31,15 L31,13 L33,13 C34.1,13 35,12.11 35,11 L35,9 C35,7.89 34.1,7 33,7 L29,7 L29,9 L33,9 L33,11 L31,11 C29.9,11 29,11.89 29,13 L29,17 L35,17 L35,15 Z"
                stroke="#000" fill="#000"></path>
        </svg>
      </button></div>

      <div class="b-container" :class="{'klick_reaktion': 8==klick}"><button @click="setLoesung()">Lösung</button></div>
    </div>
    <div v-if="feld" class="stuffen" :style="styStuffen" >
      <template v-for="(stuffe, z) in feld" :key="z">
        <template v-for="(zeile, y) in stuffe" :key="y">
          <template v-for="(zelle, x) in zeile" :key="x">
            <span v-if="zelle.i > 0" :style="styStein(x, y, z)" >
              <Stein :bild="zelle.i" :aktiv="zelle.a" :x="1" :y="0" :thema="thema" @stein-aktiv="steinAktiviert({i: zelle.i, x, y, z})"/>
            </span>
          </template>
        </template>
      </template>
    </div>


    <div class="tool2" style="width: 1130px;">
      <div class="b-container" :class="{'klick_reaktion': 9==klick}"><button @click="neuStart(true)" title="Neu starten">
        <svg width="24px" viewBox="0 0 487.622 487.622" >
          <circle style="fill:#65B3AD;" cx="243.811" cy="243.811" r="243.811"/>
          <path style="opacity:0.37;fill:#56A49E;enable-background:new    ;" d="M476.466,316.909L323.967,169.733l-67.121-30.225
            l-31.259-29.287l-6.776,39.59l-60.338,29.387l160.338,164.613l-75,24.379l-84.079-25.73l142.006,138.219
            C384.732,460.451,451.088,397.757,476.466,316.909z"/>
          <path style="fill:#FFFFFF;" d="M243.819,377.401c31.867,0,61.826-12.409,84.359-34.941c22.531-22.533,34.942-52.496,34.942-84.359
            c0-0.002,0,0.001,0-0.001c0-31.866-12.409-61.825-34.942-84.358c-16.023-16.023-36.13-27.103-58.147-32.041
            c-11.949-2.682-24.171-3.5-36.249-2.484l-8.195-28.994l-33.557,34.488l-33.557,34.488l46.646,11.816l46.646,11.816l-9.879-34.947
            c24.214-0.574,47.903,8.651,65.701,26.449c35.161,35.161,35.161,92.373,0,127.533c-35.161,35.161-92.372,35.161-127.532,0
            c-26.47-26.467-33.865-65.72-18.847-99.996l-26.674-11.688c-9.529,21.748-12.341,45.643-8.129,69.096
            c4.314,24.02,15.745,45.867,33.058,63.181C181.995,364.991,211.954,377.401,243.819,377.401z"/>
        </svg>
      </button></div>
      <input class="spiel-data" v-model="save" />
    </div>
  </div>
</template>

<script setup>
import Stein from '@/components/Stein.vue';
import {sd} from '@/helper/MahjonggData'
import { ref, computed, onMounted, inject } from 'vue'


const raster = [];
for(let z = 0; z < 7; z++) {
	const dataZ = [];
	raster.push(dataZ);
	for(let y = 0; y < 16; y++) {
		const dataY = [];
		dataZ.push(dataY);
		for(let x = 0; x < 24; x++) {
			dataY.push({i:0, a:0});
		}
	}
}
const feld = ref(raster);

let save = ref('');
let faktor = inject('groesse');
let thema = inject('thema');
const fillT = ['#BFB','#FBB'];
let moeglich = [];
let anzahl = ref(0);
let loesung = [];
const klick = ref(-1);

const emit = defineEmits(['change-groesse', 'change-thema'])

const styStuffen = computed(() => ({
  height: ((faktor.value + 1) * 72) + 'px',
  top: (-(faktor.value + 1) * 4) + 'px',
}));


onMounted(() => {
  neuesSpiel();

})

function styStein(x, y, z) {
	return {
    position: 'absolute',
    left: ((faktor.value + 1) * 3.4 * x) + 'px', // 3.63645625 
		top: Math.max(0, ((faktor.value + 1) * 4.6 * y - 6* z)) + 'px',
		height: ((faktor.value + 1) * 10) + 'px',
    zIndex: z*25 + 25 + y - x + feld.value[z][y][x].a * 200,
	}
}

function mischen(felder) {
  const reihe = [];
  sd.positionen.forEach(p => {
    if (felder[p[2]][p[1]][p[0]].i > 0) {
      reihe.push({w: felder[p[2]][p[1]][p[0]].i, s: Math.random()})
    }
  })
  reihe.sort((a, b) => a.s - b.s);
  let k = 0;
  sd.positionen.forEach(p => {
    if (felder[p[2]][p[1]][p[0]].i > 0) {
      felder[p[2]][p[1]][p[0]].i = reihe[k++].w;
    }
  })
  getZug(felder);
}

function neuesSpiel() {
  klick.value = 0;
  setTimeout(() => { klick.value = -1; }, 100);
  let reihe = sd.spiel.map( (w,i) => ({w, s: Math.random()}));
  reihe.sort((a, b) => a.s - b.s);
  const arSave = [];
  const felder = JSON.parse(JSON.stringify(raster));

  let restSteine = 72;
  let k = 0;
  sd.positionen.forEach(p => {
    felder[p[2]][p[1]][p[0]].i = reihe[k++].w;
  })
  getZug(felder);
  while (restSteine > 0) {
    while ( moeglich.length ) {
      moeglich.forEach( (m, ix) => {
        if (felder[m[0].z][m[0].y][m[0].x].i > 0 && felder[m[1].z][m[1].y][m[1].x].i > 0) {
          loesung.push(m[0]);
          felder[m[0].z][m[0].y][m[0].x].i = 0;
          loesung.push(m[1]);
          felder[m[1].z][m[1].y][m[1].x].i = 0;
          restSteine--;
        }
      });
      getZug(felder);
    }
    mischen(felder);
  }

  loesung.forEach( item => {
    felder[item.z][item.y][item.x].i = item.i;
  });

  sd.positionen.forEach(p => {
    arSave.push( sd.code.charAt( sd.index.indexOf(felder[p[2]][p[1]][p[0]].i) ) );
  })

  feld.value = felder;
  sd.zuege = [];
  sd.stein = null;
  save.value = arSave.join('');
  getZug(feld.value);
}

function neuStart(isButton) {
  if (isButton) {
    klick.value = 9;
    setTimeout(() => { klick.value = -1; }, 100);
  }
  if ( save.value ) {
    let  k = 0;
    sd.positionen.forEach(p => {
      feld.value[p[2]][p[1]][p[0]].i = sd.index[ sd.code.indexOf( save.value.charAt(k++) ) ];
    })
    sd.zuege = [];
    sd.stein = null;
    getZug(feld.value);
  }
}

function steinAktiviert(arg) {
  if ( sd.steinFrei(feld.value, arg) ) {
    if ( sd.stein ) {
      if ( sd.gleich(sd.stein, arg) ) {
        feld.value[arg.z][arg.y][arg.x].a = 0;
        sd.stein = null;
        return;
      } else if ( sd.stein.i !== arg.i ) {
        feld.value[sd.stein.z][sd.stein.y][sd.stein.x].a = 0;
        sd.stein = null;
      } else {
        if ( sd.zuege.length > sd.idx ) {
          sd.zuege.splice(sd.idx);
        }
        sd.zuege.push([{...sd.stein}, {...arg}]);
        sd.idx = sd.zuege.length;
        feld.value[sd.stein.z][sd.stein.y][sd.stein.x].a = 0;
        feld.value[sd.stein.z][sd.stein.y][sd.stein.x].i = 0;
        feld.value[arg.z][arg.y][arg.x].a = 0;
        feld.value[arg.z][arg.y][arg.x].i = 0;
        sd.stein = null;
        getZug(feld.value);
        return;
      }
    }
    sd.stein = arg;
    feld.value[arg.z][arg.y][arg.x].a = 1 ;
  }
}

function setLoesung() {
  klick.value = 8;
  setTimeout(() => { -1 }, 100);
  neuStart(false);
  sd.idx = 0;
  for ( let k = 0; k < loesung.length; k = k + 2) {
    sd.zuege.push([loesung[k], loesung[k+1]]);
  }
  function move() {
    redo()
    if ( sd.idx < sd.zuege.length ) {
      setTimeout(() => { move(); }, 100);
    }
  }
  move();
}

function undo() {
  klick.value = 1;
  setTimeout(() => { klick.value = -1; }, 100);
  if ( sd.idx > 0 ) {
    sd.idx--;
    const aend = sd.zuege[sd.idx];
    feld.value[aend[0].z][aend[0].y][aend[0].x].i = aend[0].i;
    feld.value[aend[1].z][aend[1].y][aend[1].x].i = aend[1].i;
    getZug(feld.value);
  }
}

function redo() {
  klick.value = 2;
  setTimeout(() => { klick.value = -1; }, 100);
  if ( sd.idx < sd.zuege.length ) {
    const aend = sd.zuege[sd.idx];
    feld.value[aend[0].z][aend[0].y][aend[0].x].i = 0;
    feld.value[aend[1].z][aend[1].y][aend[1].x].i = 0;
    sd.idx++;
    getZug(feld.value);
  }

}

function getStein(felder, x, y, z) {
  return {...felder[z][y][x], x, y, z};
}

function restGruppe(stein, idx, felder) {
  const grup = [];
  if(stein.i === 0) {
    return grup;
  }
  let iStein, p;
  for (let k = idx + 1; k < sd.positionen.length; k++) {
    p = sd.positionen[k];
    if (felder[p[2]][p[1]][p[0]].i > 0 ) {
      iStein = getStein(felder, p[0], p[1], p[2]);
      if (iStein.i === stein.i && !sd.gleich(stein, iStein) && (idx == -1 || sd.steinFrei(felder, iStein))) {
        grup.push(iStein);
        if (idx != -1) {
          break;
        }
      }
    }
  }
  return grup;
}

function aufhellen(grup) {
  grup.forEach( p => { feld.value[p.z][p.y][p.x].a = 1; });
  setTimeout( () => {
    grup.forEach( p => { feld.value[p.z][p.y][p.x].a = 0; });
  }, 1500);
}

function gruppe() {
  klick.value = 3;
  setTimeout(() => { klick.value = -1; }, 100);
  if ( !sd.stein ) {
    return;
  }
  const grup = restGruppe(sd.stein, -1, feld.value);
  aufhellen(grup);
}

function getZug(felder){
  const zuege = [];
  let stein;
  sd.positionen.forEach((p, i) => {
    stein = getStein(felder, p[0], p[1], p[2]);
    if (stein.i > 0 && sd.steinFrei(felder, stein)){
      const grup = restGruppe(stein, i, felder);
      if (grup?.length) {
        grup.unshift(stein)
        zuege.push( grup );
      }
    }
  })
  moeglich = zuege;
  anzahl.value = zuege.length;
}

function zeigeZug(){
  klick.value = 4;
  setTimeout(() => { klick.value = -1; }, 100);
  if ( moeglich.length ) {
    aufhellen(moeglich[0]);
  } else {
    alert('Keine Züge gefunden!');
  }
}

function setFaktor(f) {
  klick.value = f==0.5 ? 6 : 5;
  setTimeout(() => { klick.value = -1; }, 100);
  emit('change-groesse', f)
}

function chgThema() {
  klick.value = 7;
  setTimeout(() => { klick.value = -1; }, 100);
  emit('change-thema', 1 - thema.value)
}
</script>
